import { render, staticRenderFns } from "./Heading3.vue?vue&type=template&id=3f2e28b6&"
import script from "./Heading3.vue?vue&type=script&lang=js&"
export * from "./Heading3.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports